import { useEffect, useRef } from 'react';

interface UseDeepLinkFormRestoreParams {
  allPass: boolean;
  restoreCreatives: () => void;
  restoreCampaigns: () => void;
  restoreAdSets: () => void;
  restoreAd: () => void;
  onComplete: () => void;
}

const useDeepLinkFormRestore = ({
  allPass,
  restoreCreatives,
  restoreCampaigns,
  restoreAdSets,
  restoreAd,
  onComplete,
}: UseDeepLinkFormRestoreParams): void => {
  const hasCompleted = useRef(false);

  useEffect(() => {
    if (!allPass || hasCompleted.current) return;
    hasCompleted.current = true;

    restoreCreatives();
    restoreCampaigns();
    restoreAdSets();
    restoreAd();
    onComplete();
  }, [
    allPass,
    onComplete,
    restoreAd,
    restoreAdSets,
    restoreCampaigns,
    restoreCreatives,
  ]);
};

export default useDeepLinkFormRestore;
